// src/pages/LoginPage.jsx
import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

export default function LoginPage() {
  const { login }         = useAuth()
  const [email,    setEmail]    = useState('')
  const [password, setPassword] = useState('')
  const [error,    setError]    = useState('')
  const [loading,  setLoading]  = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await login(email, password)
      // Effacer le 2FA précédent — forcer la vérification OTP à chaque nouvelle connexion
      sessionStorage.removeItem('2fa_done')
      sessionStorage.removeItem('2fa_awaiting')
    } catch {
      setError('Email ou mot de passe incorrect.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Bricolage Grotesque', sans-serif",
      padding: '1rem',
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '24px',
        padding: '3rem 2.5rem',
        width: '100%', maxWidth: '420px',
        boxShadow: '0 25px 80px rgba(0,0,0,0.5)',
        position: 'relative', overflow: 'hidden',
      }}>
        {/* Barre d'accentuation supérieure */}
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: '4px',
          background: 'linear-gradient(90deg, #FF6B35, #00D4AA, #FF6B35)',
          backgroundSize: '200% 100%',
        }} />

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{
            fontSize: '2.5rem', fontWeight: '800', letterSpacing: '-1px',
            background: 'linear-gradient(135deg, #FF6B35, #00D4AA)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            marginBottom: '0.5rem',
          }}>
            ☀️ SOLSTICE
          </div>
          <p style={{ color: '#64748B', fontSize: '0.9rem', margin: 0 }}>
            Gestion commerciale multi-utilisateurs
          </p>
        </div>

        {/* Erreur */}
        {error && (
          <div style={{
            background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.4)',
            borderRadius: '12px', padding: '0.875rem 1rem',
            color: '#FCA5A5', marginBottom: '1.5rem', fontSize: '0.875rem',
            display: 'flex', alignItems: 'center', gap: '0.5rem',
          }}>
            ⚠️ {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div style={{ marginBottom: '1.25rem' }}>
            <label style={{
              display: 'block', color: '#CBD5E1', fontSize: '0.8rem',
              fontWeight: '600', marginBottom: '0.5rem', letterSpacing: '0.05em', textTransform: 'uppercase',
            }}>
              Adresse email
            </label>
            <input
              type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              required autoFocus
              placeholder="vous@entreprise.cm"
              style={{
                width: '100%', padding: '0.9rem 1rem',
                borderRadius: '12px',
                border: '2px solid rgba(255,255,255,0.08)',
                background: 'rgba(255,255,255,0.05)',
                color: 'white', fontSize: '1rem',
                outline: 'none', boxSizing: 'border-box',
                transition: 'border-color 0.2s',
              }}
              onFocus={e => e.target.style.borderColor = '#FF6B35'}
              onBlur={e  => e.target.style.borderColor = 'rgba(255,255,255,0.08)'}
            />
          </div>

          {/* Mot de passe */}
          <div style={{ marginBottom: '2rem' }}>
            <label style={{
              display: 'block', color: '#CBD5E1', fontSize: '0.8rem',
              fontWeight: '600', marginBottom: '0.5rem', letterSpacing: '0.05em', textTransform: 'uppercase',
            }}>
              Mot de passe
            </label>
            <input
              type="password" value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              style={{
                width: '100%', padding: '0.9rem 1rem',
                borderRadius: '12px',
                border: '2px solid rgba(255,255,255,0.08)',
                background: 'rgba(255,255,255,0.05)',
                color: 'white', fontSize: '1rem',
                outline: 'none', boxSizing: 'border-box',
              }}
              onFocus={e => e.target.style.borderColor = '#FF6B35'}
              onBlur={e  => e.target.style.borderColor = 'rgba(255,255,255,0.08)'}
            />
          </div>

          {/* Bouton */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '1rem',
              background: loading
                ? 'rgba(255,107,53,0.4)'
                : 'linear-gradient(135deg, #FF6B35 0%, #E55A2B 100%)',
              border: 'none', borderRadius: '14px',
              color: 'white', fontSize: '1rem', fontWeight: '700',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: loading ? 'none' : '0 8px 24px rgba(255,107,53,0.35)',
            }}
          >
            {loading ? '⏳ Connexion en cours…' : '🔐 Se connecter'}
          </button>
        </form>

        <p style={{
          color: '#334155', textAlign: 'center',
          marginTop: '1.75rem', fontSize: '0.78rem', lineHeight: 1.5,
        }}>
          Mot de passe oublié ?<br/>Contactez votre administrateur SOLSTICE.
        </p>
      </div>
    </div>
  )
}
